export default __webpack_public_path__ + "static/media/pod.3c73e377.svg";